import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export const CHECKOUT_URL = 'https://holarutaclara.com/cart/48234238509246:1';
type BuyButtonProps = {
  label?: string;
  variant?: 'solid' | 'outline';
  fullWidth?: boolean;
};
export function BuyButton({
  label = 'Comprar ahora por $9 USD',
  variant = 'solid',
  fullWidth = false
}: BuyButtonProps) {
  const base = 'group inline-flex items-center justify-center gap-2.5 px-8 py-4 text-sm font-semibold uppercase tracking-[0.12em] transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-terracotta focus-visible:ring-offset-2 focus-visible:ring-offset-cream';
  const styles = variant === 'solid' ? 'bg-terracotta text-cream hover:bg-cocoa' : 'border border-terracotta text-terracotta hover:bg-terracotta hover:text-cream';
  return <a href={CHECKOUT_URL} onClick={() => trackAddToCart()} aria-label={`${label} — ir al pago seguro`} className={`${base} ${styles} ${fullWidth ? 'w-full' : ''}`} data-id="element-24" data-mp="3spobosw4r5e">
      {label}
      <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-25" data-mp="1ca3fqx5qjsbn" />
    </a>;
}